
export interface IAllDownloadResponse { }

/** 下载状态 */
export enum EDownloadEnableStatus {
  /** 生成中 */
  action = 0,
  /** 可下载 */
  ok = 1,
  /** 生成失败 */
  fail = 2,
}

export const downloadEnableStatusLabel = {
  [EDownloadEnableStatus.action]: '生成中',
  [EDownloadEnableStatus.ok]: '可下载',
  [EDownloadEnableStatus.fail]: '生成失败',
};

export const downloadEnableStatusStyle = {
  [EDownloadEnableStatus.action]: 'primary',
  [EDownloadEnableStatus.ok]: 'success',
  [EDownloadEnableStatus.fail]: 'danger',
};